var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.eligibleForDiscountPromotion)?_c('discount-promo-notification-box'):(_vm.benefitType === _vm.BENEFIT_TYPES.FREE_MONTHS)?_c('free-months-benefit-notification-box'):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }